module.exports = __webpack_public_path__ + "img/icon_sec3_3@2x.206e0931.png";